import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/authContext';
import '../../styles/admin.css';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const onChange = e => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const onSubmit = async e => {
    e.preventDefault();
    if (!credentials.username || !credentials.password) {
      return toast.error('Please fill in both fields');
    }
    setLoading(true);
    try {
      await login(credentials.username, credentials.password);
      toast.success('Welcome back, Admin!');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="login-container">
        <form onSubmit={onSubmit} className="login-card">
          <div className="login-header">
            <i className="fas fa-user-shield"></i>
            <h1>El Hiba Para Admin</h1>
            <p>Connectez-vous pour accéder au tableau de bord</p>
          </div>
          <div className="form-group">
            <label>Username</label>
            <input 
              name="username"
              value={credentials.username}
              onChange={onChange}
              required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input 
              name="password" 
              type="password"
              value={credentials.password}
              onChange={onChange}
              required />
          </div>
          <button 
            type="submit" 
            className="btn btn-primary btn-full"
            disabled={loading}>
            {loading ? 'Signing In…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;